import systemSettingForm from '../schemas/systemSetting.json';
import produce from 'immer';

const useSystemSettingForm = (setting) => {
  let settingSchema = systemSettingForm;
  if (setting.spec && setting.spec.ValueOptions) {
    if (setting.spec.ValueType !== 'list') {
      settingSchema = produce(settingSchema, (draft) => {
        draft.properties.Value.oneOf = setting.spec.ValueOptions.map(
          (elem) => ({
            const: elem,
            title: elem,
          })
        );
        delete draft.properties.Value.items;
      });
    } else {
      settingSchema = produce(settingSchema, (draft) => {
        const anyOf = setting.spec.ValueOptions.map((elem) => ({
          type: 'number',
          enum: [elem],
          title: elem,
        }));
        draft.properties.Value.items = {
          type: 'string',
          uniqueItems: true,
          anyOf: anyOf,
        };
        delete draft.properties.Value.oneOf;
      });
    }
  } else
    settingSchema = produce(settingSchema, (draft) => {
      delete draft.properties.Value.items;
      delete draft.properties.Value.oneOf;
    });
  return { settingSchema };
};
export default useSystemSettingForm;
